import $ from 'jquery';

$(document).ready(function() {
	if ($('.js-universal-info-text').length > 0 && $(window).width() > 1023) {
		$('.js-universal-info-text').each(function() {
			if ($(this).height() > 200) {
				$(this).addClass('small');
			}
		});
	}
});


// WEBPACK FOOTER //
// ./src/js/pages/universal/universal-info-text.js